export enum RuleCategorizationType {
    Residential = 0,
    Commercial = 1,
}
